import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../../pages/lomavisCreator';
import { INSTAGRAM } from '../../../../../config/constants';
import EditorConfirmation from '../../../cards/editorExitConfirmation';
import {
  setModalUiContent,
  updateIGProductTagModalCloseState
} from '../../../../../redux/slices/lomavisCreator/lomavisCreator';
import IGImageCard from '../../../cards/IGTagImageCard';

interface Props {
  items: any[];
  setSelectedFile: React.Dispatch<any>;
  selectedFile: any;

  setCurrentFileIndex: React.Dispatch<React.SetStateAction<number>>;
  editorChanged: boolean;
  setEditorChanged: React.Dispatch<React.SetStateAction<boolean>>;
}
const IGCarousel: React.FC<Props> = ({
  items,
  setSelectedFile,
  selectedFile,
  setCurrentFileIndex,
  editorChanged,
  setEditorChanged
}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [currentItem, setCurrentItem] = useState(items[0]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const tagsArray = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[INSTAGRAM]?.additional_publication_data
        .instagram_shopping_product_tags
  );
  return (
    <div
      style={{ overflowY: 'auto' }}
      className="w-100 h-100 d-flex flex-column justify-content-start align-items-start gap-2 mx-auto"
    >
      <EditorConfirmation
        handleClose={() => setShow(false)}
        handleClear={() => {
          setSelectedFile(currentItem);
          setEditorChanged(false);
          dispatch(
            updateIGProductTagModalCloseState({
              state: false
            })
          );
          dispatch(
            setModalUiContent({
              modal: 'IGProductTags',
              attribute: 'allowClose',
              value: false
            })
          );
          setCurrentFileIndex(currentIndex);
        }}
        show={show}
      />
      {items.map((item, index) => {
        return (
          <div key={item?.id || index} className="mx-auto">
            <div
              onClick={() => {
                setCurrentItem(item);
                setCurrentIndex(index);
                if (editorChanged) {
                  setShow(true);
                } else {
                  setSelectedFile(item);
                  setCurrentFileIndex(index);
                }
              }}
              className={`cursor-pointer`}
            >
              <IGImageCard
                active={selectedFile.id === item.id}
                image={item.preview_image}
                item={item}
                key={item.id}
                tagCount={tagsArray ? tagsArray[item.id]?.length : 0}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default IGCarousel;
